import { useStatsigClient } from '@statsig/react-bindings';

/**
 * Hook to get the navigation label for Tutorials from a Statsig experiment.
 *
 * This hook wraps the 'nav_tutorials_label' experiment and returns the label
 * to be displayed in the navigation bar. The experiment allows A/B testing
 * different label variations (e.g., "Tutorials" vs "Video Tutorials").
 *
 * @returns The navigation label text (defaults to 'Tutorials')
 *
 * @example
 * const tutorialsLabel = useNavTutorialsLabelExperiment();
 * // Use in JSX: <Button>{tutorialsLabel}</Button>
 */
export function useNavTutorialsLabelExperiment(): string {
  const { client } = useStatsigClient();
  // 'nav_tutorials_label' matches the console experiment slug
  const exp = client.getExperiment('nav_tutorials_label'); // exposure auto-logged
  return exp.get('button_label', 'Tutorials'); // default guard
}
